/**
 * Career, programmes and research, taken from James Carl-Rhule's CV.
 * Keep the same shape (title/desc/foot, or a detailPath for a full write-up)
 * so the Experience page keeps working.
 */
export const careerHighlights = [
  {
    tag: "Centre for National Culture · Bolgatanga, Upper East",
    title: "Acting Regional Director",
    desc: "Regional leadership and oversight of the Centre's mandate: annual work plans and budgets, staff supervision and appraisal, cultural festivals, conferences and workshops, and oversight of the Performance Management System.",
    foot: "2025 – 2026",
  },
  {
    tag: "Centre for National Culture · Bolgatanga, Upper East",
    title: "Acting Deputy Regional Director",
    desc: "Coordinated regional programmes, research activities and administrative functions, and strengthened collaboration with public institutions, schools, cultural practitioners and development partners.",
    foot: "2023 – 2025",
  },
  {
    tag: "National Commission on Culture · Accra",
    title: "Head of Monitoring and Evaluation",
    desc: "Led monitoring and evaluation across the Commission's programmes: built assessment tools, coordinated data collection and analysis, and prepared performance reports for management and policy decisions.",
    foot: "2022 – 2023",
  },
  {
    tag: "Centre for National Culture · Fijai-Sekondi, Western Region",
    title: "Head of Research and Documentation",
    desc: "Implemented research and documentation policy, documented the region's artistic and cultural resources, and explored the commercial potential of cultural assets.",
    foot: "2017 – 2022",
  },
  {
    tag: "Centre for National Culture · Fijai-Sekondi, Western Region",
    title: "Technical Department",
    desc: "Maintained technical plant and equipment, designed technical frameworks for cultural productions, and installed, inspected and repaired electrical and electronic equipment.",
    foot: "2006 – 2016",
  },
  {
    tag: "Aggrey Memorial School, Sekondi · Gowrie JHS, Bongo",
    title: "National Service Person / Class Teacher · Pupil Teacher",
    desc: "Classroom teaching at Aggrey Memorial School (2004 – 2005) and Mathematics at Gowrie Junior Secondary School (2000 – 2001).",
    foot: "2000 – 2005",
  },
];

export const culturalProgrammes = [
  {
    tag: "Education · Sekondi",
    title: "ICT Training for Students",
    desc: "Training students from Sekondi in ICT, alongside a wider interest in ICT education for Junior High School students in Ghana and in educational policy.",
    foot: "Since 2013 · Trainer",
  },
  {
    tag: "Heritage · Upper East Region",
    title: "Cultural Heritage Programmes",
    desc: "Coordinated the 2024 and 2025 Cultural Heritage Programmes in the Upper East Region.",
    foot: "2024 – 2025 · Coordinator",
  },
  {
    tag: "UNESCO · Ghana",
    title: "Intangible Cultural Heritage Inventory",
    desc: "Coordinated Ghana's 2023 UNESCO Intangible Cultural Heritage inventory programme.",
    foot: "2023 · Coordinator",
  },
  {
    tag: "National Festival of Arts and Culture · Techiman",
    title: "NAFAC 2024",
    desc: "Organised artists and artisans from the region to take part in the 2024 National Festival of Arts and Culture in Techiman, Bono East Region.",
    foot: "2024 · Organiser",
  },
  {
    tag: "Trade & Culture · Mali",
    title: "Basket Supply Project",
    desc: "Executed a project involving the supply of baskets to Mali.",
    foot: "2025",
  },
  {
    tag: "Child Protection · Upper East Region",
    title: "Ghanaians Against Child Abuse (GACA)",
    desc: "Organised the 2023 and 2024 editions of the GACA programme in the Upper East Region, and the GACA Child Marriage Programme.",
    foot: "2023 – 2024 · Organiser",
  },
  {
    tag: "Monitoring & Evaluation · National",
    title: "NAFAC@60 Monitoring & Pre-NAFAC Survey",
    desc: "Monitored and evaluated NAFAC@60 in Cape Coast, and ran a pre-NAFAC survey assessing the city's readiness to host it.",
    foot: "Cape Coast",
  },
  {
    tag: "Performance Review · Centres for National Culture",
    title: "Mid-Year & End-of-Year Reviews",
    desc: "Organised the 2023 Mid-Year and 2022 End-of-Year performance review programmes for the Centres for National Culture.",
    foot: "2022 – 2023 · Organiser",
  },
  {
    tag: "Arts & Education · Regional",
    title: "Festivals & Competitions",
    desc: "Coordinated regional arts and cultural festivals, school drama festivals, debates, choral music festivals and traditional cooking competitions, and supported cultural programming for primary, junior and senior high schools.",
    foot: "Ongoing",
  },
];

export const leadershipInitiatives = [
  {
    tag: "MSc Thesis · UDS, Tamale · Supervisor: Dr. Stephen Tetteh",
    title: "Structure, Leadership & Digital Technology in Public Institutions",
    desc: "A survey of 87 public-sector staff in Ghana. Digital technology was the strongest predictor of sustainable development, ahead of leadership style and organisational structure. Together the three explained 75% of the variation.",
    detailPath: "/research/public-institutions",
  },
  {
    tag: "Digital Innovation",
    title: "Video Library Management System",
    desc: "Designed and developed a video library management system to support digital information management.",
  },
  {
    tag: "Engineering Innovation",
    title: "Electrical Changeover Switch",
    desc: "Designed and developed an electrical changeover switch, applying practical engineering knowledge and technical problem-solving.",
  },
  {
    tag: "Cultural Research · Western Region",
    title: "Origins of the Centre for National Culture",
    desc: "Researched the origins and development of the Centre for National Culture in the Western Region, and explored heritage sites in Sekondi for tourism development.",
  },
];

export const leadershipRoles = [
  { role: "Assistant Divisional Secretary", org: "PSWU · Centre for National Culture Division · 2019 – 2025", desc: "Staff representation and employee relations for the division." },
  { role: "Local Union Chairman", org: "PSWU · Western Region · 2018 – 2022", desc: "Chaired the local union branch for the Centre for National Culture." },
  { role: "Sekondi Branch Secretary", org: "Public Services Workers' Union · 2016 – 2022", desc: "Institutional communication and administration for the Sekondi branch." },
  { role: "Estate Officer", org: "Centre for National Culture · Western Region · 2017 – 2022", desc: "Estate management for the Centre in the Western Region." },
];
